import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';

function ConnectStore(props) {
  const redirectToPrintfulOAuth = () => {
    window.location.href = process.env.REACT_APP_PRINTFUL_OAUTH_REDIRECT
  }
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        width: '100%',
        margin: 'auto',
        marginTop: '50px',
      }}
    >
        <IconButton
            aria-label="back"
            onClick={props.onPrevious}
            sx={{
            position: 'absolute',
            top: 50,
            left: 50,
            backgroundColor: 'transparent',
            color: '#ff4c15ff',
            '&:hover': {
                backgroundColor: 'rgba(255, 76, 31, 0.04)',
            },
            size: 'large',
            }}
        >
            <ArrowBackIosRoundedIcon fontSize="large" />
        </IconButton>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0px 12px 36px rgba(0, 0, 0, 0.3)',
          padding: '50px',
          width: '20%', // Adjust the width as needed for your layout
          borderRadius: '20px',
        }}
      >
        <Typography variant="h5" sx={{ marginBottom: '50px', fontWeight: 'bold', width: '100%', textAlign: 'center' }}>Connect a store to get started...</Typography>
        <Button
          variant="contained"
          onClick={ redirectToPrintfulOAuth } // Use navigate to go to /home
          sx={{
            borderRadius: '10px',
            backgroundColor: '#ff4c15ff',
            '&:hover': {
              backgroundColor: '#e2400f',
            },
            color: 'white',
            padding: '10px 20px', // Adjust padding to match button size requirements
          }}
        >
          Connect Printful Store
        </Button>
      </Box>
    </Box>
  );
}

export default ConnectStore;
